/**
 * Created by virus_zhh on 2017/6/17.
 */
import Stage from './stage'

export {
  Stage
}

import colors from './colors'

const colorKeys = Object.keys(colors)

export {
  colors,
  colorKeys
}

import icons from './icons'
import faicons from './faicons'

export {
  icons,
  faicons
}

import * as common from './common'
export {
  common
}

import constant from './constant'
export {
  constant
}

import * as ajax from './ajax'

export {
  ajax
}

import * as axios from './axios'

export {
  axios
}



// WEBPACK FOOTER //
// ./src/untils/index.js